import { useCallback } from 'react';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { returnToPreviousMacroWizardPath } from 'actions/searchActions';
import { extractLastIncomingMessage, getselectedConversationId } from 'extractFromState';
import { handleError } from 'services/ErrorService/ErrorService';
import { getEnglishMessageBody } from 'util/messageUtil';
import { getTroubleshootingAgentAssistResponse } from '../api';
import {
  trackAgentAssistUsefulnessCopied,
  trackAgentAssistUsefulnessNotHelpful,
  trackAgentAssistRecommendationFailure,
} from '../analytics';
import { useTranscriptForML } from './useTranscriptForML';

export default function useAgentAssistTroubleshooter() {
  const dispatch = useDispatch();
  const { transcript } = useTranscriptForML();
  const conversationId = useSelector(getselectedConversationId);
  const lastIncomingMessage = useSelector(extractLastIncomingMessage);
  const mutation = useMutation(getTroubleshootingAgentAssistResponse, {
    onError(error) {
      const message = error.message;
      handleError({ error, customMessage: message, showPopup: true });
      dispatch(returnToPreviousMacroWizardPath());
      trackAgentAssistRecommendationFailure(message);
    },
  });

  const message = getEnglishMessageBody(lastIncomingMessage);
  const macroText = mutation.data?.requestDetails?.agent_message;
  const { mutate } = mutation;

  const request = useCallback(() => {
    mutate({
      transcript,
      message,
      conversationId,
      langCode: 'en-US',
    });
    // transcript cannot be contained in here because it causes the request function to be redefined, causes tests to hand forever
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [message, conversationId, mutate]);

  const trackNotHelpfulClick = () => trackAgentAssistUsefulnessNotHelpful(macroText, lastIncomingMessage.messageId);
  const trackCopyClick = () => trackAgentAssistUsefulnessCopied(macroText, lastIncomingMessage.messageId);

  return {
    ...mutation,
    request,
    macroText,
    trackNotHelpfulClick,
    trackCopyClick,
  };
}
